import {
  SlSpinner
} from "./chunk.KAOWVGX3.js";
import {
  n
} from "./chunk.D5EJUUKV.js";
import {
  __decorateClass
} from "./chunk.K2NRSETB.js";

// src/components/spinner/spinner.ts
var FadvSpinner = class extends SlSpinner {
};
FadvSpinner = __decorateClass([
  n("fadv-spinner")
], FadvSpinner);

export {
  FadvSpinner
};
